export type UserItem = {
	avatr: string;
	name: string;
	date: string;
	text: string;
};

/**
 * 国家文案配置
 */
export const USER_COUNTRY_CONIFG: Record<string, UserItem[]> = {
	'en-US': [
		{
			avatr: 'https://web-data.zmlearn.com/image/hWCkSwxU2NTLxAkCv5n7oB/touxiang1%402x.png',
			name: 'Britney',
			date: 'Jul 2, 2021',
			text: `I can only speak on my experience thus far and Becan has been a great influence on my boy.
			A polite, friendly human being with a great deal of patience. He explains how to  solve the Mathematics problem so that my boy could understand. I'm really pleased with AirClass.`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/5bKM1B9KXCVf7RBmp5gxku/touxiang2%402x.png',
			name: 'Kaly',
			date: 'May 30, 2021',
			text: `My son was really weak at Essay and Writing. It is a great source of extras for him. My son and I love the various classes there because we have a lot of perfect tutors and classes to choose from. I strongly believe that he can do well, with the help of Michael, his AirClass teacher, in SAT next year.`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/9aMepFVsFMxbPz3xdkAXWB/touxiang3%402x.png',
			name: 'Daniel',
			date: 'May 15, 2021',
			text: `I have had an excellent experience with AirClass! My kid loves the classes. Should there be any issues with a particular class, their service is excellent! They always take feedback from my kid and address it.`,
		},
	],
	'en-CA': [
		{
			avatr: 'https://web-data.zmlearn.com/image/pWG7kyRVRa4ed4p6cJmt8e/t1%402x.png',
			name: 'Anthony',
			date: 'Jan 13, 2021',
			text: `I received a great tutor who had a fantastic way of teaching the content, allowing me to gain an understanding far beyond that I gained in the classroom`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/4Xqdk6VpdQAZtypdfPwvHm/t2%402x.png',
			name: 'Cathy',
			date: 'Mar 18, 2021',
			text: `A professional agency providing highly qualified and academic tutors with an in depth knowledge of the subject they teach. We are very happy with our tutor.`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/cgRwcrShdTgKCJZ4wpFyHo/t3%402x.png',
			name: 'Able',
			date: 'May 29, 2021',
			text: `Emily is always well prepared for the lesson. After each lesson, she prepares a cheatsheet on the topic which she has taught my child so that he is able to use it to revise and aid him when he does the homework that she has set for him. She is clear, supportive and encouraging.`,
		},
	],
	'en-AU': [
		{
			avatr: 'https://web-data.zmlearn.com/image/jazmWiCxXibEQRVyggKPxL/touxiang1%402x.png',
			name: 'Lacey',
			date: 'Feb 04, 2021',
			text: 'I have had an excellent experience with AirClass! My kids love their classes. Should there be any issues with a particular class, their service is excellent! They always take feedback from my kids or me seriously and address it quickly.',
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/mPQ3rN5cdVDZne3ENgfDRd/touxiang2%402x.png',
			name: 'Ashley ',
			date: 'Mar 04, 2021',
			text: 'Fun classes! I have been very happy with everything! So far my daughter has taken classes twice and likes her teacher. Customer service has been fantastic as well.',
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/461kstEV694ufZxRuLqWB6/touxiang3%402x.png',
			name: 'Sam',
			date: 'Aug 1, 2021',
			text: 'I love AirClass! It is a great source of extras for my homeschooled kid. My son and I love the various classes there because we have a lot of perfect tutors and classes to choose from. Hopefully, my kid can get an A in Physics with the help of AirClass.',
		},
	],
	'en-GB': [
		{
			avatr: 'https://web-data.zmlearn.com/image/xdxGWGQvh9ubDVcQAYshcg/u1%402x.png',
			name: 'Jacob',
			date: 'Jul 2, 2021',
			text: `A brilliant session and it's worthy. Love it! Cathrine, my History teacher is flexible about time, even on short notice. My histroy grades have reached A within 6 months. Overall, very happy with the teacher and the company!`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/7UtRH43ATk2B6HRhgdfQW/u2%402x.png',
			name: 'Cindy',
			date: 'May 30, 2021',
			text: `A tutor has impacts on a student's lifetime. So many thanks to my daughter's Chemistry tutor. He gave her many chances to express herself and this definitely developed her confidence. If she gets something wrong, the tutor will make a timely correction with full patience.`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/ewwpCKuRNgptoxMsmg37h3/u3%402x.png',
			name: 'Annie',
			date: 'May 15, 2021',
			text: `My son is extremely satisfied with AirClass and we highly recommend it.  You know what, he just got an A* in Maths! That's marvelous and we can't even believe it because his predicted grade was C. So, it turns out we've found a perfect platform! It couldn't be better.`,
		},
	],
	'en-IE': [
		{
			avatr: 'https://web-data.zmlearn.com/image/fi3jJZdPCz5uJczHe53Hbu/touxiang1%402x.png',
			name: 'Aaron',
			date: 'Feb 04, 2021',
			text: 'My daughter and I are very happy with Nickolas and they both engaged and worked very well together. Nick had a good way about him when teaching the class and kept Evelyn engaged and we have seen a big change in her confidence since starting the lectures with Nick.',
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/3W4Shp1ASjcFtyoAmxpmvA/touxiang2%402x.png',
			name: 'Megan',
			date: 'Mar 11, 2021',
			text: `I can only speak on my experience thus far and Becan has been a great influence on my boy.
			A polite, friendly human being with a great deal of patience. He explains how to solve the Mathematics problem so that my boy could understand. I'm really pleased with AirClass.`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/8q5GNzZ2LD6UEzXBB8niNb/touxiang3%402x.png',
			name: 'Nicole',
			date: 'Apr 28, 2021',
			text: `My daughter's tutor is very intelligent and has her own unique way of making the tutor time fun and interesting. Her tutor is also nice and she also helps her with other subjects even though she was a Maths tutor. I'm very satisfied with her and my daughter has also improved a lot !`,
		},
	],
	'en-NZ': [
		{
			avatr: 'https://web-data.zmlearn.com/image/gEYgHgM9GRLRmd1iYZS5ka/touxiang1%402x.png',
			name: 'Amanda',
			date: 'Jun 13, 2020',
			text: `My tutor managed to save my maths skills in less than a month. Definitely an excellent tutoring website, I would recommend it to anyone willing to invest some time and money into improving their future (especially for university).`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/9XChWJPeHpafWCYgaeYQ3K/touxiang2%402x.png',
			name: 'Fairy',
			date: 'Apr 01, 2021',
			text: `The tutor is excellent - responsive to student's needs and provides insightful analysis into texts. My son really enjoys the discussions with Victor and appreciates his guidance in creating clear arguments.`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/5rR67vdfHfTatkhZBgoRxo/touxiang3%402x.png',
			name: 'Brittany',
			date: 'Dec 15, 2020',
			text: 'My sons history tutor has been a great support, helping him to improve and increase his speed in writing timed essays and having a clearer focus.',
		},
	],
};
